<script>
  import { createEventDispatcher } from "svelte";
  import { guidV4 } from "@itslearning/atlas/generate/guid";

  const dispatch = createEventDispatcher();

  /** @type {boolean} */
  export let checked = false;
  /** @type {boolean} */
  export let disabled = false;
  /** @type {string} */
  export let label = undefined;
  /** @type {string} */
  export let id = undefined;
  /** @type {string} */
  export let name = undefined;
  /** @type {boolean} */
  export let labelHidden = false;
  /** @type {boolean} */
  export let small = false;
  /** @type {string} */
  export let description = undefined;
  /** @type {string} */
  export let describedBy = undefined;
  /** @type {string} */
  export let elementLegacyColor = '';
  /** @type {string} */
  export let value = '';

  let checkbox;

  $: disabledClass = disabled ? "disabled" : "";

  $: smallClass = small ? "prom-checkbox--small" : "";

  let labelText;

  $: {
    if (!label || typeof label !== "string") {
      throw new TypeError("Label must be supplied");
    }

    labelText = label;
  }

  $: labelHiddenClass = labelHidden ? "screen-reader" : "";

  if (description && !describedBy) {
    describedBy = "prom-checkbox__information_id-" + guidV4();
  }

  /** @private */
  function handleChanged() {
    dispatch("change", { checked });
  }
</script>

<label class="prom-checkbox {disabledClass} {smallClass}">
  <input
      bind:this={checkbox}
      class="prom-checkbox__input"
      type="checkbox"
      bind:checked
      {disabled}
      {name}
      {value}
      {id}
      on:change={handleChanged}
      aria-describedby={description ? describedBy : undefined}
    />

  <span class="prom-checkbox__custom-check {elementLegacyColor}" />

  <span class="prom-checkbox__label-text {labelHiddenClass}">{labelText}</span>
</label>

{#if description}
  <span id={describedBy} class="prom-checkbox__description">{description}</span>
{/if}
